import { useState } from "react";
import { useEffect } from "react";
import { useLocalStorage } from '@mantine/hooks';


export const useAuthExtrasHook = () => {
    const [ hasToken, setHasToken ] = useState(false);
    const [ token ] = useLocalStorage<string | null>({ key: 'authToken', defaultValue: null });


    useEffect(() => {
        if(!!token) {
            console.log('token found -- inside hook event');
            setHasToken(true);
        } else {
            setHasToken(false);
        }
    }, [token]);

    const injectHeader = (req: Request) => {
        if(token) {
            req.headers.set('Authorization', `Bearer ${token}`);
        }
    }

    return { hasToken, injectHeader };
}